import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderDocument } from 'app/core/store/edit-florder-detail/florder-detail.interface';

@Component({
  selector: 'app-order-documents',
  templateUrl: './order-documents.component.html',
  styleUrls: ['./order-documents.component.scss'],
})
export class OrderDocumentsComponent {
  @Input() documents: any;
  @Output() downloadDocument = new EventEmitter();

  download(document: OrderDocument) {
    this.downloadDocument.emit({ documentId: document.documentId, extension: document.extension });
  }
}
